var _defs, _circle, _circle2, _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _polygon3, _path6, _polygon4, _path7, _path8, _path9, _polygon5, _path0, _path1, _path10, _polygon6, _path11, _polygon7, _path12, _circle3, _path13, _path14, _path15, _path16, _path17, _polygon8, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polygon9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse, _path38, _polygon0, _path39, _path40, _rect, _rect2, _rect3, _polygon1, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _polygon10, _rect0, _path41, _path42, _ellipse2, _path43, _path44, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_18",
    "data-name": "Layer 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1158.48 627.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2,.cls-30{fill:#deb87d;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-35,.cls-5{fill:#00479b;}.cls-6{fill:#4d4d4d;}.cls-7{fill:url(#radial-gradient);}.cls-8{stroke:#abd5ef;fill:url(#linear-gradient-4);}.cls-23,.cls-24,.cls-25,.cls-30,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-8{stroke-miterlimit:10;}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-6);}.cls-11{fill:url(#linear-gradient-7);}.cls-12{fill:url(#linear-gradient-8);}.cls-13{fill:url(#linear-gradient-9);}.cls-14{fill:url(#linear-gradient-10);}.cls-15{fill:url(#linear-gradient-11);}.cls-16{fill:url(#linear-gradient-12);}.cls-17,.cls-33{fill:#d1d4d4;}.cls-18{fill:#e1bf7d;}.cls-19{fill:#ebf6fc;}.cls-20{fill:url(#linear-gradient-13);}.cls-21,.cls-34{fill:#9cc8ff;}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:#4296cf;stroke:#4296cf;}.cls-24,.cls-25,.cls-26{fill:#ffe28e;}.cls-24{stroke:#ffeab9;}.cls-25{stroke:#ffe28e;}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#radial-gradient-2);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{stroke:#deb87d;}.cls-31{fill:url(#linear-gradient-17);}.cls-32{fill:#636363;}.cls-33,.cls-34,.cls-35,.cls-36{stroke:#fff;}.cls-36{fill:#727272;}.cls-37{fill:none;stroke:#545454;stroke-width:3px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 434.21,
    y1: 295.22,
    x2: 891.98,
    y2: 295.22,
    gradientTransform: "translate(319.1 896.97) rotate(-90.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbedf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e3f1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#f9fcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -326.8,
    y1: 295.26,
    x2: -285.38,
    y2: 366.99,
    gradientTransform: "translate(671.69 -68.08) rotate(-6.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#a1cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#afd3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c6e0fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e5f3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 456.03,
    y1: 301.16,
    x2: 522.94,
    y2: 390.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c1ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#77c7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8ecded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9ed2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a8d4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#abd5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e6f3fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebf6fc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -374.75,
    cy: 266.09,
    r: 19.24,
    gradientTransform: "translate(801.82 39.39) scale(0.94 0.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -315.39,
    y1: 362.47,
    x2: -315.39,
    y2: 362.47,
    gradientTransform: "translate(794.47)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -500.76,
    y1: 318.26,
    x2: -441.15,
    y2: 421.51,
    gradientTransform: "matrix(0.83, 0, 0, 1, 842.39, 0.4)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 419.49,
    y1: 289.84,
    x2: 489.09,
    y2: 435.83,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -249.5,
    y1: 362.08,
    x2: -234.74,
    y2: 387.63,
    gradientTransform: "translate(878.51 221.12) rotate(44.07)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 537.43,
    y1: 339.68,
    x2: 522.68,
    y2: 398.49,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 188.18,
    y1: 166.63,
    x2: 212.96,
    y2: 209.54,
    gradientTransform: "matrix(-0.96, 0.27, 0.27, 0.96, 512.88, 60.28)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 466.66,
    y1: 301.96,
    x2: 445.86,
    y2: 382.61,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 364.83,
    y1: 173.45,
    x2: 401.91,
    y2: 237.67,
    gradientTransform: "matrix(0.13, 0.99, 0.99, -0.13, 173.35, -26.93)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 464.98,
    y1: 358.81,
    x2: 555.62,
    y2: 396.88,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 910.75,
    y1: 365.71,
    x2: 861.97,
    y2: 369.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbd9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#b9d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a4ccff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#a0caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#add2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#c3ddff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfe4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 967.11,
    y1: 371.87,
    x2: 891.77,
    y2: 377.54,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 872.61,
    y1: 649.11,
    x2: 919.18,
    y2: 649.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#75a6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#235fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03438f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 953.78,
    cy: 305.14,
    fx: 966.0544409260841,
    fy: 317.54370961365214,
    r: 17.45,
    gradientTransform: "matrix(-0.82, 0.06, 0.06, 0.85, 1684.27, 7.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5dd9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c69c6d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 983.79,
    y1: 652.78,
    x2: 1021.51,
    y2: 652.78,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 996.99,
    y1: 371.38,
    x2: 932.35,
    y2: 370.07,
    xlinkHref: "#linear-gradient-13"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 602.85,
    cy: 228.89,
    r: 228.88
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 478.45,
    cy: 349.66,
    r: 11.63
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "427.45 332.59 439.71 319.79 385.45 260.59 373.2 273.39 427.45 332.59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M513.66,379.32c4-4.27,8-8.49,12-12.7v.44c-3-1.78-5.81-3.75-8.57-5.76s-5.43-4.1-8-6.25c-5.23-4.29-10.21-8.8-15-13.46-2.4-2.34-4.79-4.69-7.1-7.12l-3.45-3.64c-1.13-1.23-2.29-2.44-3.35-3.74a42.92,42.92,0,0,1-5.53-8.55,37.46,37.46,0,0,1-2-5,26.35,26.35,0,0,1-1.2-5.7h.47l-12.26,12.81v-.44a33.28,33.28,0,0,1,8.18-1.14,18.28,18.28,0,0,1,5.63.71,11,11,0,0,1,4,2.14,12,12,0,0,1,1.52,1.58l1.42,1.67a146.51,146.51,0,0,1,10.72,14.7c3.46,5.35,6.88,11.19,10.55,17.68S509.2,371.08,513.66,379.32Zm0,.65c-4.59-1.62-9.71-4.54-15.08-7.85A173.07,173.07,0,0,1,482,360.2a197.37,197.37,0,0,1-16.41-14.9l-2-2a19.09,19.09,0,0,1-1.88-2.13,18.77,18.77,0,0,1-2.82-5.26,20.88,20.88,0,0,1-1.15-6.68,24,24,0,0,1,1.39-8.54v-.44l12.26-12.8.07-.07.4.07a27,27,0,0,1,5.58,1.7,37,37,0,0,1,4.79,2.42,42.74,42.74,0,0,1,8,6.25c1.21,1.17,2.31,2.43,3.43,3.66l3.34,3.76c2.21,2.51,4.34,5.09,6.46,7.69,4.23,5.2,8.29,10.56,12.11,16.13,1.91,2.79,3.76,5.63,5.53,8.55s3.48,5.89,5,9.05l.14.28-.15.16C522,371.39,517.82,375.7,513.65,380Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "293.64 562.19 316.7 569.46 375.49 378.56 352.43 371.29 293.64 562.19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M380.17,609.07c7.65,2.34,15.24,4.69,22.84,7.09l-.47.24c2.72-16.53,6.29-32.85,10.12-49.13q11.61-48.64,26.7-96.28a203,203,0,0,1,15-34.57,101.76,101.76,0,0,1,7-10.92l.25.47-23.06-7.27.47-.25a54.13,54.13,0,0,1,4,13.91,60.27,60.27,0,0,1-1.17,24.07c-.78,3.22-2.47,8-3.49,11.24-4.92,14.95-10.3,29.82-16.22,44.93-12.58,31.93-27.09,64.74-41.92,96.47Zm-.66.35c3.63-31.82,9.63-62.6,16.88-94.44,3.87-16.7,8.29-33.65,13.17-50.51,2.4-8.47,4.95-17.16,9.43-24.85,4.87-8.42,10.64-15.84,19.29-21.39l.42-.26.05,0,23.05,7.27.23.07,0,.39a100.93,100.93,0,0,1-.39,12.95,202.62,202.62,0,0,1-7,37c-12,39.88-25.53,79.33-41.32,117.9-3.23,7.84-6.59,15.65-10.2,23.38-7.88-2.48-15.76-5-23.59-7.55Z",
    transform: "translate(-86.2 -47.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.18,238.31c-.26,17.42-13.2,37.54-31.19,37.63-18.74.09-33.09-21.6-31.45-39,1-10.69,7.87-17.8,9.11-19.05,6.49-6.5,13.7-7,24.3-7.71,9.69-.66,14.53-1,19.36,2.72C480.24,220.54,480.19,237.48,480.18,238.31Z",
    transform: "translate(-86.2 -47.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M468.13,310l-38.67-.39a34.24,34.24,0,0,0,8.4-11,27.55,27.55,0,0,0,2.46-7.25,49.63,49.63,0,0,0,.56-6.73c.09-1.93.1-3.89.11-5.07,0-1.48,0-2.71,0-3.61h16.85c-.07.89-.15,2.13-.22,3.61-.09,1.79-.17,3.5-.12,5.31a37,37,0,0,0,.68,6.25,33.22,33.22,0,0,0,3.17,8.24A64.84,64.84,0,0,0,468.13,310Z",
    transform: "translate(-86.2 -47.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M479.09,362.47",
    transform: "translate(-86.2 -47.05)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "431.83 572.51 408.17 577.8 370.02 382.23 393.69 376.95 431.83 572.51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M518.27,619.72l-23.84,5.4-.25.06-.09-.28c-14.22-47.85-24.82-96.6-34.28-145.56a264.62,264.62,0,0,1-4-37.28,125.91,125.91,0,0,1,.18-12.72l0-.29.19,0c.1,0,23.67-5.29,23.76-5.31a54.21,54.21,0,0,1,8.56,11.6,92.75,92.75,0,0,1,9.44,24.77,1223.27,1223.27,0,0,1,20.35,159.65Zm-.48-.31C502.5,570,488.92,522.67,478.45,473c-2.71-11.82-4.44-23.66-2.39-35.82a57.14,57.14,0,0,1,3.55-13.09l.34.22-23.66,5.28.21-.33a167.44,167.44,0,0,1,9,23.63c2.46,8,4.51,16,6.25,24.16q9.81,48.86,17,98.19c2.36,16.45,4.46,33,6,49.58l-.34-.22,23.48-5.16Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "352.67 416.88 397.38 412.68 392.69 351.24 347.97 355.44 352.67 416.88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M445.19,456.43c6.47-1.46,13-3.24,19.3-5a43.11,43.11,0,0,0,9.15-3.35c2.86-1.42,5.54-2.26,8.69-1.75l-12.18,14.44c1.08-15.84,9.56-31.14,9.65-47.09.14-4.51-.66-10.83-.94-15.38l0,0c-10.75,1-22.76,2.47-33.51,3.43a75.4,75.4,0,0,0-11.11,1.8l1-1.14a53.48,53.48,0,0,0,9,19.9l3.54,5.12a22.68,22.68,0,0,1,4.51,12.18,8.37,8.37,0,0,1-.2,3c-1.24,4.16-4.52,9.63-6.92,13.8Zm-12.64,15c-2.8,1.64-6.72,1.93-8.09-1.56-1-2.87-.86-6.58-1.07-9.73-.62-13.48,3.14-27.88,6.77-40.87a85.12,85.12,0,0,0,3-17.88l.88,0c7.55.43,14.95-.79,22.44-1.28,6.57-.42,16-1.38,22.4-1.86l.57,7.68a64.2,64.2,0,0,0,5.43,22.76c2.1,5,4.66,9.95,6.84,14.93,3.75,7.82,5.89,17.46,7.87,25.77l-14.78,3.71a31.68,31.68,0,0,1-13.67.36,78.34,78.34,0,0,0-13.2-1.26c-7.41-.34-18.15-.71-25.42-.81Z",
    transform: "translate(-86.2 -47.05)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M443.13,308.47c3.42,5.93,9.22,9.52,15.05,9.12a14.19,14.19,0,0,0,7.45-2.85,13.75,13.75,0,0,1,6.17,4.61,15,15,0,0,1,2.44,9.21c-.31,19.22,8.21,71.39,8.49,73.12.51,3.14,1.39,8.15,2.73,14.32a1,1,0,0,1-.22.56.76.76,0,0,1-.53.23l-54.94-.3a.76.76,0,0,1-.74-.8c.07-7.45.47-18.29,1.45-21.23,2.89-8.62,5.32-25.3,3.51-60.6.52-2,1.26-5,2-8.76.61-3.17.69-4.22,1-5.63A23.48,23.48,0,0,1,443.13,308.47Z",
    transform: "translate(-86.2 -47.05)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M444.24,299a12.48,12.48,0,0,1,5.45,2.86,12.81,12.81,0,0,1,2,2.32l.1.15,0,0,0,0,.07.09a5.59,5.59,0,0,0,.55.71,8.85,8.85,0,0,0,1.21,1.17,6,6,0,0,0,2.42,1.25,3.09,3.09,0,0,0,1.72-.08,5.16,5.16,0,0,0,1.65-1.11l3.78-3.56,6.23,2.26a24.58,24.58,0,0,1,9.61,6.19A25.77,25.77,0,0,1,484.91,322a33.34,33.34,0,0,1,1,5.41l.14,1.13c.05.31.1.5.15.75l.31,1.41.3,1.4q.19.75.36,1.5c.23,1,.41,2,.59,3a41.9,41.9,0,0,1,.65,6.25c0,1.06,0,2.13,0,3.2s0,2.15-.08,3.23c-.15,4.33-.42,8.73-.85,13.17-.77,8.86-2.22,17.93-2.94,26.93a113.83,113.83,0,0,0-.42,13.41A118.76,118.76,0,0,0,485.52,416h0a.84.84,0,0,1-.69.8c-.37,0-.73,0-1.1,0l-2.18,0-4.36,0-8.73-.05L451,416.6l-17.45-.09h-3.28c-.35,0-.76.07-1-.23s-.22-.68-.22-1l0-1.09,0-2.18q.09-4.36.33-8.72c.09-1.45.19-2.9.33-4.35.08-.72.16-1.45.26-2.17.06-.36.1-.72.18-1.07a2,2,0,0,0,.08-.55,2,2,0,0,0-.22-.64,3.65,3.65,0,0,1-.25-.66,3.49,3.49,0,0,1,0-.56c0-.36,0-.72,0-1.1,0-.74,0-1.46,0-2.19,0-1.46-.14-2.92-.28-4.37a114.3,114.3,0,0,0-3.38-17.21c-1.49-5.67-3.25-11.29-4.87-16.87s-3.16-11.17-4.44-16.75l.54-5.25c0-2,.14-4.05.29-6,.06-1,.16-2,.19-2.94l.05-1.46c0-.51.06-1.1.16-2a19.6,19.6,0,0,1,.66-3.16,18.89,18.89,0,0,1,1.2-3.08,17.49,17.49,0,0,1,3.86-5.15,13.82,13.82,0,0,1,2.55-1.87c.46-.27.91-.51,1.39-.74s1-.4,1.49-.58a13.66,13.66,0,0,1,3.26-.65l.88-.05.43,0a14.93,14.93,0,0,1,1.8-1.29,12.87,12.87,0,0,1,4.52-1.64A9.72,9.72,0,0,1,444.24,299ZM442,318a6.79,6.79,0,0,0,3.52.83,9.28,9.28,0,0,0,3.94-1,9.73,9.73,0,0,0,1.52-1l.15.31.32.61c.44.8.77,1.44,1.13,2,.17.29.31.55.49.81s.28.47.44.7c.31.43.56.78.8,1.07a9.38,9.38,0,0,0,1,1.1,1.06,1.06,0,0,1,.19.19c0,.07,0,0-.1.19a11.38,11.38,0,0,0-.4,1.35c-.16.62-.34,1.28-.53,1.93-.35,1.29-.78,2.52-1.22,3.76-.87,2.49-1.78,4.95-2.75,7.37l.55-5.25a153.2,153.2,0,0,1-3.27,18.14c-1.48,6.05-3.34,12.08-5.38,18-1,3-2.14,5.93-3.25,8.85s-2.4,5.81-3.69,8.64q-1,2.13-2.08,4.18c-.34.68-.74,1.36-1.11,2-.18.34-.4.67-.6,1a2.58,2.58,0,0,1-.32.49,2.89,2.89,0,0,1-.56.38,1.53,1.53,0,0,0-.51.41,2.46,2.46,0,0,0-.15.53c-.08.35-.12.71-.18,1.07-.1.72-.18,1.45-.26,2.17-.14,1.45-.24,2.9-.33,4.35q-.24,4.35-.33,8.72l0,2.18,0,1.09c0,.36-.07.77.22,1s.67.22,1,.23h3.28l17.45.09,17.46.1,8.73.05,4.36,0h2.18c.37,0,.74,0,1.09,0a.76.76,0,0,0,.58-.76v0a118.35,118.35,0,0,0-3.57-12.8c-.74-2.12-1.39-4.25-2.17-6.36s-1.56-4.23-2.42-6.33c-3.37-8.43-7.29-16.82-10.28-25.44A127.18,127.18,0,0,1,463,352c-.54-2.2-1-4.45-1.39-6.72a39.84,39.84,0,0,1-.39-6.93c0-1.18.13-2.4.25-3.6.06-.6.12-1.2.2-1.8L462,331l.27-1.89c.05-.3.09-.66.14-.91a2.72,2.72,0,0,1,.15-.51c.17-.51.29-.86.36-1.16a3,3,0,0,0,.13-1c0-.24-.39-.71-1.24-1.16l10-1.3a25,25,0,0,1-10.4,4.24A23.59,23.59,0,0,1,450,326.25a26.87,26.87,0,0,1-9-5.39,27.55,27.55,0,0,1-3.4-3.62c-.51-.64-1-1.29-1.44-2L436,315l-.09-.12,0-.07,0,0,.06.1a7,7,0,0,0,1.57,1.61A7.35,7.35,0,0,0,442,318Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "471.5 344.17 476.33 336.74 416.14 299.88 411.31 307.31 471.5 344.17"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M557.63,390.91c1.54-2.46,3.06-4.88,4.63-7.29l.1.45a83.26,83.26,0,0,1-8.79-2.54c-2.86-1-5.66-2-8.41-3.16-5.51-2.26-10.86-4.79-16.08-7.52-2.61-1.38-5.21-2.77-7.75-4.25q-1.92-1.1-3.81-2.23c-1.25-.77-2.53-1.5-3.73-2.35a33.84,33.84,0,0,1-6.64-6.06,31.86,31.86,0,0,1-2.77-3.92,23,23,0,0,1-2.21-4.84l.44-.09-4.83,7.42-.11-.45a34.66,34.66,0,0,1,7.05-3.65,16.46,16.46,0,0,1,5.11-1.17,8.71,8.71,0,0,1,3.93.66,8.92,8.92,0,0,1,1.64.94l1.59,1.06a114.27,114.27,0,0,1,12.42,9.9c4.15,3.75,8.37,8,13,12.76S551.91,384.6,557.63,390.91Zm.14.63c-4.31.17-9.42-.81-14.84-2.11a128.34,128.34,0,0,1-17.14-5.66,158,158,0,0,1-17.68-8.54L505.94,374a16.52,16.52,0,0,1-2.11-1.37,15.22,15.22,0,0,1-3.6-3.94,18.6,18.6,0,0,1-2.41-5.78,23.67,23.67,0,0,1-.48-8.27l-.1-.45,4.83-7.43,0,0,.41-.07a22.57,22.57,0,0,1,5.31-.23,31.17,31.17,0,0,1,4.76.69,33.5,33.5,0,0,1,8.41,3.16c1.31.68,2.54,1.48,3.79,2.25s2.49,1.58,3.72,2.38c2.48,1.59,4.89,3.27,7.3,5,4.81,3.41,9.5,7,14,10.9,2.26,1.94,4.48,4,6.64,6.06a86.61,86.61,0,0,1,6.25,6.68l.22.27-.12.18C561.15,386.51,559.46,389.05,557.77,391.54Z",
    transform: "translate(-86.2 -47.05)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480.94,251.55c-.2,7.48-.57,21.14-10.06,28.75a22.84,22.84,0,0,1-12.09,4.78,23.9,23.9,0,0,1-16.12-4.68,25.46,25.46,0,0,1-6.84-7.85c-2.24-4-2.41-6.69-4.13-17.17-2.17-13.19-2.52-12.64-2.25-14.1C431.33,231.44,444,225.1,454,224c3.41-.39,15.88-1.8,22.86,7C481.35,236.58,481.17,243.39,480.94,251.55Z",
    transform: "translate(-86.2 -47.05)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M484.73,221.88c.68,5.37-5.21,10.12-5.89,10.65-4,3.12-7.2,2.7-22.51,2-12.38-.54-15.26-.48-19.69-2.94-1.23-.69-9.52-5.43-8.95-10.2.38-3.19,4.51-5,8.3-6.42,5.91-2.19,12.47-2.36,22.12-2.6,8.83-.23,13.24-.34,17.63.91C478.35,214.06,484.11,216.91,484.73,221.88Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "396.3 327.58 406.44 313.05 343.75 262.86 333.6 277.39 396.3 327.58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M482.45,374.31c3.31-4.83,6.59-9.61,9.93-14.39l.06.43c-3.24-1.3-6.32-2.81-9.35-4.37s-6-3.23-8.9-5c-5.82-3.44-11.44-7.13-16.91-11-2.73-1.94-5.45-3.9-8.1-5.94l-4-3.08c-1.31-1-2.64-2.05-3.89-3.17a43.32,43.32,0,0,1-6.77-7.6,38,38,0,0,1-2.73-4.62,26.73,26.73,0,0,1-2.07-5.45l.47-.07-10.15,14.53-.06-.43a33.2,33.2,0,0,1,7.9-2.38,18.07,18.07,0,0,1,5.67-.16,11,11,0,0,1,4.25,1.51,13,13,0,0,1,1.73,1.32l1.67,1.44a147.33,147.33,0,0,1,12.84,12.88c4.24,4.76,8.52,10,13.14,15.86S476.78,366.85,482.45,374.31Zm.09.64c-4.78-.89-10.29-3-16.11-5.44a172.65,172.65,0,0,1-18.2-9.24,195.31,195.31,0,0,1-18.5-12.21l-2.26-1.7a21.9,21.9,0,0,1-2.18-1.82,19.08,19.08,0,0,1-3.59-4.76,21.25,21.25,0,0,1-2.17-6.43,24.18,24.18,0,0,1,.07-8.65l-.06-.44,10.15-14.53.05-.07h.41a26.3,26.3,0,0,1,5.77.83,37.71,37.71,0,0,1,5.11,1.65,43,43,0,0,1,8.9,4.95c1.37,1,2.65,2,3.95,3.09l3.87,3.2c2.57,2.14,5.08,4.37,7.57,6.61,5,4.49,9.8,9.17,14.43,14.09q3.48,3.69,6.78,7.6c2.19,2.62,4.34,5.29,6.32,8.17l.18.27-.12.17C489.48,365.2,486,370.1,482.54,375Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "458.9 343.68 462.11 335.88 392 311.48 388.78 319.27 458.9 343.68"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M545,390.45c1-2.57,2-5.1,3.06-7.63l.18.41c-3.23-.12-6.4-.43-9.53-.85s-6.23-.92-9.3-1.51c-6.14-1.17-12.19-2.63-18.15-4.31-1.49-.43-3-.83-4.47-1.29l-4.43-1.37c-1.48-.47-2.95-1-4.41-1.45s-2.94-1-4.37-1.58a37.94,37.94,0,0,1-8.22-4.59,33.49,33.49,0,0,1-3.79-3.25,24.66,24.66,0,0,1-3.45-4.21l.39-.17-3.21,7.8-.19-.41a32,32,0,0,1,6.25-4.74,17,17,0,0,1,4.95-2,10,10,0,0,1,4.21,0,11.47,11.47,0,0,1,1.94.61l1.9.74a132.19,132.19,0,0,1,15.24,7.27c5.17,2.84,10.51,6.11,16.3,9.84S537.85,385.51,545,390.45Zm.26.57c-4.57.88-10.09.83-16,.54a149.56,149.56,0,0,1-18.76-2.36,177.61,177.61,0,0,1-19.82-4.94l-2.48-.79a18.19,18.19,0,0,1-2.45-.91,17,17,0,0,1-4.55-3.1,19.28,19.28,0,0,1-3.81-5,23.07,23.07,0,0,1-2.52-7.79l-.18-.41,3.21-7.8,0,0,.37-.13a24.29,24.29,0,0,1,5.32-1.16,33.62,33.62,0,0,1,5-.2,38.54,38.54,0,0,1,9.3,1.51c1.49.42,2.94,1,4.4,1.48s2.91,1.05,4.35,1.6l4.33,1.67c1.45.57,2.87,1.18,4.3,1.76,5.72,2.4,11.37,5,16.91,7.9q4.15,2.16,8.23,4.59c2.71,1.62,5.39,3.34,8,5.26l.27.2-.09.21C547.5,385.72,546.36,388.39,545.23,391Z",
    transform: "translate(-86.2 -47.05)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 507.37,
    cy: 321.54,
    r: 12.61
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M383.59,623.85c7.48,2.13,11.63,9.13,14.91,14.67,3.58,6,10.52,20.64,5.15,24.44s-19.09-5.33-25.21-10.37c-3.77-3.12-12.66-10.44-12.39-18.43a10.61,10.61,0,0,1,3-7C372.51,623.55,378.35,622.37,383.59,623.85Z",
    transform: "translate(-86.2 -47.05)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M926.26,250.45l27.16,2.34a8.73,8.73,0,0,1,7.91,3.81,8.92,8.92,0,0,1-1.46,11A76.27,76.27,0,0,0,949,278.21c-7.63,9.15-8.34,14.45-11.66,15.15-4,.84-10.81-5-23.55-33.28Z",
    transform: "translate(-86.2 -47.05)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M926.12,250c9.11,1.09,18.18,1.77,27.34,2.31,8-1,15.32,3.78,17.51,12.62a22.32,22.32,0,0,1-.76,12.84l-1.27,1.14a87.29,87.29,0,0,0,3.23,17c.67,2.95,2,6.86,2.18,9.84a11.21,11.21,0,0,1-1.51,5.6c-7,13.23-22,21.47-36.85,21.16-16.57-.22-32.73-10.77-37.75-26.82-3.94-12.68-2.85-26.07.47-38.8l5-19.89c7.58-.74,15.56-.43,22.44,3Zm.28,1a84.7,84.7,0,0,0-2.5,22.24l5-19.89c8.49,3.7,15,7.32,22,10.26,2.18.87,4.59,2,6.93,1.63l.09-.08.18-.18a4.07,4.07,0,0,0,.3-.34,3.71,3.71,0,0,0-.22-1.12,8.66,8.66,0,0,0-1.47-1.93c-10.43-9.41-27.3-9.1-38.8-1.73a29.56,29.56,0,0,0-8.63,8.11,7,7,0,0,0-.67,1.27c-.09.12,0,.29,0,.42l.3-.16a1.68,1.68,0,0,0,.36-.21c.52-.43,1-.79,1.55-1.32,4.56-4.19,9.77-8,15.82-9.9,7.71-2.51,16.27-2.58,24.19-1.76l-1.27,1.14a5.88,5.88,0,0,0,4.24,3.69c3.48.74,6.17-2.92,4-5.78a5.29,5.29,0,0,0-4.36-2c-8.94-1-18-1.91-27-2.37Z",
    transform: "translate(-86.2 -47.05)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M893,416.77c-2.55,7.51-6,6.43-9.75,1.51-.35-2.39-.94-6.26-1.87-11-1.29-6.68-1.82-7.81-2.56-12.64-.25-1.64-.17-1.34-1.28-12.75-.7-7.17-.87-8.66-1.14-12.1-.3-3.83-.49-7-.61-9.18l20.32-.83c.07,1.7.18,4.29.32,7.46.39,8.62.51,9.63.53,12.36a103.85,103.85,0,0,1-.65,12.71c-.7,6.05-1.44,7.42-2.35,14.13C893.35,410.88,893.11,414.52,893,416.77Z",
    transform: "translate(-86.2 -47.05)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M975.05,429.65h.1a5.85,5.85,0,0,0,5.42-6.1c-.07-1.58-.13-3.35-.17-5.27-.12-6.66.18-7.87-.12-12.64-.09-1.62-.12-1.32-1.47-12.46-.85-7-1-8.47-1.48-11.81-.15-1.06-.3-2.06-.44-3a5.84,5.84,0,0,0-6.79-4.87l-9.68,1.71a5.84,5.84,0,0,0-4.74,6.78c.09.46.17.94.26,1.43,1.5,8.32,1.6,9.31,2.17,11.92a94.41,94.41,0,0,0,3.48,12c2.06,5.62,3.14,6.77,5.56,13,.77,2,1.42,3.8,2,5.4A5.82,5.82,0,0,0,975.05,429.65Z",
    transform: "translate(-86.2 -47.05)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "808.2 352.08 795.15 353.45 792.12 288.9 805.17 287.53 808.2 352.08"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M894.72,399.41c-4.41.54-8.88,1.06-13.33,1.52l-.23,0-.23-.42a59.06,59.06,0,0,1-3.59-7.92c-1-2.65-1.87-5.31-2.62-8a120.74,120.74,0,0,1-3.38-16c-.38-2.68-.7-5.36-.93-8.05-.11-1.34-.22-2.68-.29-4a38.77,38.77,0,0,1-.12-4,22.64,22.64,0,0,1,1.86-8.17,23.73,23.73,0,0,1,2.32-4.15,22.17,22.17,0,0,1,3.71-4.22l.38-.44,13.05-1.37.47.4a31.66,31.66,0,0,1,9.17,4,19,19,0,0,1,5.07,4.67,11.87,11.87,0,0,1,2.2,4.87,11.67,11.67,0,0,1,.19,2.42l0,2.4a109.38,109.38,0,0,1-1.67,18.7,80.09,80.09,0,0,1-4.65,16.3,44.52,44.52,0,0,1-3.32,6.55A18.73,18.73,0,0,1,894.72,399.41Zm-.64-.55c-1.85-4.15-3.35-7.77-4.84-11.21l-4.07-9.59c-2.51-6-4.58-11.17-6.17-16a70.58,70.58,0,0,1-3.18-13.58l-.18-1.63a4.89,4.89,0,0,1,0-1.62,6.08,6.08,0,0,1,1.81-3.2,20.94,20.94,0,0,1,4.69-3.4,60.35,60.35,0,0,1,8.8-4l.46.4-13,1.37.38-.44a22.25,22.25,0,0,1,4.1,3.85,23.85,23.85,0,0,1,2.69,3.92,22.45,22.45,0,0,1,2.62,8,36.34,36.34,0,0,1,.26,4c.05,1.35.07,2.7.09,4,0,2.7,0,5.4-.17,8.1a120.72,120.72,0,0,1-1.87,16.26q-.74,4.08-1.86,8.18a59.32,59.32,0,0,1-2.83,8.22l-.46-.4C885.56,399.64,889.79,399.24,894.08,398.86Z",
    transform: "translate(-86.2 -47.05)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M918.31,411.14l23.79-2.26q-2.45,22.78-4.88,45.57l-14.1,3.28Q920.72,434.43,918.31,411.14Z",
    transform: "translate(-86.2 -47.05)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M918,410.88c8.06-.84,16.18-1.66,24.28-2.42l.22.46,23.06,48.56L974.35,476l-44.86,9.13-44.3,9,10-33.49a184.92,184.92,0,0,1,11.9-30.29c3.4-6.88,7.31-13.2,10.93-19.45Zm.62.51c6.89,17.19,18.16,32.59,32.45,43.45l-34.31-24.48,14-3.67-21.88,24.73,32.81-42.58.44.44c-7.84.75-15.65,1.44-23.52,2.11Z",
    transform: "translate(-86.2 -47.05)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M892.43,627.51l22.28,1.17,6.81-204.51-14.25,7.32c-4.18,36-7.74,73.46-10.45,112.35Q893.82,586.77,892.43,627.51Z",
    transform: "translate(-86.2 -47.05)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M892.71,627.25l22,1.2-.25.22c.45-14.91,1-29.83,1-44.75,0-35.81-6-73.11-4-108.9.44-8.55,3.41-17.22,6-25.4a81,81,0,0,0,2.89-12.7c.59-4.24.62-8.51.87-12.76l.4.26L914.47,428l-7.14,3.62c-.77,7.59-1.83,16.34-2.5,24.35l-.55,6.12c-1,6.83,2.18,13.21,5.58,19.05s6.53,12.15,5.47,18.93c-3.39,36.7-8.37,73.35-17.27,109.25-.89,3.36-2.29,8.8-3.32,12.14-.63,2.24-1.48,3.47-2,5.81Zm-.57.52c-2.25-8-3.57-16.83-4.84-25.1-4.86-34.9-4.82-70.25-1.84-105.26.12-9.58,8.15-16.33,13.46-23.52A23.17,23.17,0,0,0,903.55,462l.73-6.11c.89-7.06,2-17.56,2.94-24.5,3.54-1.8,10.65-5.61,14.17-7.47l.41-.22v.48c-.35,8.65-.14,17.15,2.05,25.66,2,8.34,4.39,17.17,4.26,25.73-.34,24.65-4.44,51.95-7.89,76.51-3.66,25.4-4.44,51-5.27,76.61v.23h-.24l-22.56-1.14Z",
    transform: "translate(-86.2 -47.05)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M914.19,422.2l35.49-1.6-3.47-73.67c-2-.09-4.84-.15-8.21,0-3,.11-5.3.32-9.15.66-5.25.48-5.65.64-8.46.82a93.13,93.13,0,0,1-9.66.14Z",
    transform: "translate(-86.2 -47.05)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M914.37,422l8.79-.35,8.83-.4c5.89-.25,11.79-.57,17.68-.87l-.22.24c-.17-3.07-.28-6.14-.55-9.21a73.77,73.77,0,0,0-1.41-9.16,96.69,96.69,0,0,0-6.12-18.17c-2.61-6-5.53-12.05-8-18.09a108,108,0,0,1-5.67-18.19l17.68,17.61c-1.23.24-2.45.49-3.66.69-.61.1-1.21.21-1.81.29s-1.18.15-1.85.31a76.26,76.26,0,0,1-7.78,1.23c-1.4.17-2.66.31-4.05.42l-1.19.1-1.46.09c-1,0-1.92.08-2.83.07a69.6,69.6,0,0,1-10.75-.87l19.9-20.12c-.36,2.53-.71,5.07-1.21,7.67s-1,5.22-1.54,7.91c-1.1,5.39-2.47,11-3.89,17.07s-3,12.47-4.47,19.39S915.86,413.94,914.37,422Zm-.35.39c-2.07-4.21-4.1-9.14-6.19-14.49s-4.21-11.19-6.21-17.45-3.94-12.87-5.62-19.77c-.87-3.44-1.66-6.95-2.41-10.5s-1.43-7.14-2.07-10.75l-3-16.7,22.87-3.42,7-1.05L920,328l.75-.13,1-.14c1.56-.22,3.24-.37,4.79-.47,3.28-.18,6.64-.18,9.95-.07.8,0,1.73.14,2.59.23s1.76.2,2.64.31c1.75.2,3.49.46,5.22.71l19.42,2.77-1.73,14.84a107.89,107.89,0,0,1-3.94,18.65c-1.85,6.24-4.2,12.5-6.23,18.75a96.75,96.75,0,0,0-4.39,18.66,74,74,0,0,0-.54,9.26c0,3.08.2,6.14.31,9.21v.23h-.22c-6,.23-11.87.44-17.81.72L923,422Z",
    transform: "translate(-86.2 -47.05)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M922.21,355.59",
    transform: "translate(-86.2 -47.05)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "916.88 574.52 895.61 581.1 839.79 389.47 861.06 382.89 916.88 574.52"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1003.38,621.73l-21.47,6.74-.28.09-.14-.32c-13-30.7-23.81-62.31-34-94-8.47-27.88-18.56-55.55-21.28-84.76a106.49,106.49,0,0,1-.52-13.18l.21-.07,21.27-6.57.07,0,.35.25c8,5.92,13.26,13.51,17.71,21.89A86.16,86.16,0,0,1,970.47,464c6.25,20.73,11.47,42.14,16.2,63,7,31.91,12.9,63,16.71,94.76Zm-.59-.31c-20.3-47-39.5-94-54.49-142.31-3.86-11.51-6.47-23.14-4.77-35.43a55.16,55.16,0,0,1,3.4-13.64l.42.22-21.26,6.58.22-.41a108.34,108.34,0,0,1,6.44,11.11,224.53,224.53,0,0,1,14.07,34.88c11.84,39.9,22.37,80.19,30.76,121,1.67,8.18,3.22,16.39,4.55,24.67l-.42-.23,21.08-6.41Z",
    transform: "translate(-86.2 -47.05)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M859.55,319.71",
    transform: "translate(-86.2 -47.05)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M843,305.63",
    transform: "translate(-86.2 -47.05)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M954.1,390.86",
    transform: "translate(-86.2 -47.05)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M895.89,334.38",
    transform: "translate(-86.2 -47.05)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M866.9,318.36",
    transform: "translate(-86.2 -47.05)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M878.72,651.47c-4.8,7.26-7.2,10.89-5.64,13,3.71,5.13,26.06,1.26,38.85-10.79,3.16-3,8.69-8.2,6.9-13.54-1.88-5.62-11.14-9.24-18.28-8.63C891.37,632.33,886.26,640.06,878.72,651.47Z",
    transform: "translate(-86.2 -47.05)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M908.3,333.93c1.54,5.42,4.5,7,5.21,7.4,5.24,2.6,14-1.13,19.22-10.8a28.32,28.32,0,0,1-2.13-3.25,24.08,24.08,0,0,1-2.58-6.16,43,43,0,0,1-.91-5.82c-.2-1.68-.34-3.38-.42-4.41-.11-1.29-.18-2.37-.23-3.15l-14.52,1.06c.11.77.27,1.84.42,3.13.19,1.56.37,3,.44,4.62a32.62,32.62,0,0,1-.19,5.49c0,.08,0,.19,0,.3a28.42,28.42,0,0,1-2.16,7.07C909.9,330.63,909.2,332.17,908.3,333.93Z",
    transform: "translate(-86.2 -47.05)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M899.13,276.8c-.36,6.49-.57,11.09,1.2,16.36a30.12,30.12,0,0,0,6,10c3.79,4.68,6.41,7.9,10.31,8.23s6.68-2.25,11.59-6.62c3.14-2.79,6.56-5.83,9.14-11.45,2-4.41,2.51-8.2,3.14-13,1-7.92,1.64-12.67.14-17.46-2.85-9.07-11.71-13.24-18.27-13.82s-16,2-20.45,10.49C899.88,263.46,899.63,267.9,899.13,276.8Z",
    transform: "translate(-86.2 -47.05)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M911,242.31a45.8,45.8,0,0,1,18,1.49,49.52,49.52,0,0,1,15.53,7.89c2.52,1.77,3.37,3.36,5.09,6.34,1.08,1.87,3.16,3.78,3.14,4.39l-.16,5.48c-.09,2.94-2.69,5.07-5.86,5h-.08a16.13,16.13,0,0,0-5.42,1,58.58,58.58,0,0,1-8.87,1.55,30.28,30.28,0,0,1-12.67-.9,23.5,23.5,0,0,1-9.41-5c-3-2.69-3-4.39-6.4-8.15a35.29,35.29,0,0,0-3.13-3.12,5.41,5.41,0,0,1-1.39-6.72l2.86-6Z",
    transform: "translate(-86.2 -47.05)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1019.33,659.18c2.11,8.42,3.16,12.63,1,14.17-5.21,3.67-25-7.19-33-22.73-2-3.84-5.47-10.56-2-15,3.63-4.72,13.57-5.16,20.1-2.29C1013.76,637,1016,645.94,1019.33,659.18Z",
    transform: "translate(-86.2 -47.05)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M868.85,362.15l.07,0a3.88,3.88,0,0,1,5.52,1.65c.82,2.09,1.83,4.61,3,7.44C880.28,378,881,379,882.88,384c.65,1.67.5,1.38,4.49,13.13,2.5,7.38,3,8.91,4.19,12.47,1.76,5.43,1.85,5.7,1.9,6,.3,1.56.17,4.13-2.59,7.89l-2.4.88c-3.66,0-8.18-.52-10.25-3.57-.31-.46-.1-.36-1.26-4.26-2.67-9-3-10-3.8-12.87-1.74-6.46-2.67-11.62-3-13.5-1.13-6.5-.93-8.09-2.08-15.34-.52-3.25-1.06-6.07-1.52-8.3A4.06,4.06,0,0,1,868.85,362.15Z",
    transform: "translate(-86.2 -47.05)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 868.32,
    cy: 349.1,
    rx: 6.73,
    ry: 7,
    transform: "translate(-109.32 17.12) rotate(-4.18)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M897.65,433.68",
    transform: "translate(-86.2 -47.05)"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "875.76 361.98 893.23 358.89 881.18 285.43 863.71 288.52 875.76 361.98"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M962.18,408.73c5.75-1.09,11.45-2.14,17.18-3.15l-.3.43a81.89,81.89,0,0,1-4.29-8.73c-1.27-2.94-2.41-5.89-3.45-8.86a179.94,179.94,0,0,1-5.29-18c-.72-3-1.4-6.06-2-9.11-.3-1.52-.59-3.05-.85-4.57s-.55-3.06-.69-4.61a32.53,32.53,0,0,1,.44-9.5,30,30,0,0,1,1.42-4.94,24,24,0,0,1,2.64-5.15l.43.3L950,335.94l.3-.43a42.26,42.26,0,0,1,8.47,2.95,18.41,18.41,0,0,1,4.83,3.13,8.3,8.3,0,0,1,2.31,3.47,8.71,8.71,0,0,1,.38,1.92l.23,2a108.11,108.11,0,0,1,.38,16.53c-.27,5.86-.89,12.16-1.71,19.23l-1.35,11.23C963.32,399.91,962.84,404.05,962.18,408.73Zm-.43.6a31.37,31.37,0,0,1-4.65-5.56,76.21,76.21,0,0,1-4.37-7.14A122.88,122.88,0,0,1,945,379.14a153.35,153.35,0,0,1-5.65-20.21l-.52-2.63a15.06,15.06,0,0,1,.43-8.38,20,20,0,0,1,3.32-6.05,27.23,27.23,0,0,1,7-6.24l.3-.43,17.46-3.08h0l.41.31a24.2,24.2,0,0,1,4.15,4,31.28,31.28,0,0,1,2.93,4.24,32.43,32.43,0,0,1,3.45,8.86c.36,1.51.57,3.05.81,4.58s.46,3.07.67,4.61c.41,3.07.74,6.16,1,9.26a179.44,179.44,0,0,1,.74,18.74c0,3.14-.18,6.31-.44,9.5a83.88,83.88,0,0,1-1.28,9.64l-.07.38-.23,0C973.58,407.36,967.64,408.36,961.75,409.33Z",
    transform: "translate(-86.2 -47.05)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M406.23,685.24",
    transform: "translate(-86.2 -47.05)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 800.92,
    y: 336.41,
    width: 92.17,
    height: 70.55,
    transform: "translate(-44.36 779.91) rotate(-53.18)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 761.93,
    y: 323.2,
    width: 81.92,
    height: 27.96,
    transform: "translate(-34.42 730.77) rotate(-53.18)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 766.29,
    y: 343.46,
    width: 103.56,
    height: 14.93,
    transform: "translate(-39.33 748.43) rotate(-53.18)"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "824.49 345.26 812.22 361.65 799.94 378.05 777.56 361.29 802.11 328.5 824.49 345.26"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 774.53,
    y: 353.36,
    width: 103.56,
    height: 7.47,
    transform: "translate(-40.97 757.5) rotate(-53.18)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 751.25,
    y: 295.42,
    width: 6.92,
    height: 59.34,
    transform: "translate(-44.04 687.36) rotate(-53.18)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 772.33,
    y: 267.26,
    width: 6.92,
    height: 59.34,
    transform: "translate(-13.05 692.96) rotate(-53.18)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 561.61,
    y: 328.48,
    width: 102.63,
    height: 78.55,
    transform: "translate(342.21 1011.27) rotate(-106)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 626.89,
    y: 333.74,
    width: 91.2,
    height: 31.13,
    transform: "translate(435.94 1044.99) rotate(-106)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 593.59,
    y: 349.29,
    width: 115.3,
    height: 16.62,
    transform: "translate(400.87 1035.14) rotate(-106)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "452.28 316.97 458.57 338.89 464.86 360.81 494.78 352.22 482.21 308.39 452.28 316.97"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 582.58,
    y: 356.6,
    width: 115.3,
    height: 8.31,
    transform: "translate(383.77 1028.58) rotate(-106)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M552.65,386.67s-162.92,206.79-253.31,147S87.38,628,87.38,628",
    transform: "translate(-86.2 -47.05)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1244.56,603.33s-199.26-16.52-199.24-98.86-148.6-94.7-148.6-94.7",
    transform: "translate(-86.2 -47.05)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 890.59,
    cy: 392.94,
    rx: 9.76,
    ry: 10.15,
    transform: "translate(-112.45 18.86) rotate(-4.18)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M912.22,402.87v-.11c.49-3.27,3-5.64,5.44-5.11s5.59,1.18,9.06,1.83c8.29,1.56,9.8,1.51,15.73,2.83,2,.45,1.63.41,15.41,4.19,8.65,2.38,10.46,2.85,14.6,4.05,2.57.75,4.89,1.45,6.89,2.06,2.25.69,3.39,3.72,2.54,6.73L979,429.57c-.84,3-3.32,4.81-5.53,4.09l-4.87-1.58c-10.26-3.32-11.48-3.63-14.69-4.78a152.26,152.26,0,0,1-14.71-6.15c-6.86-3.32-8.22-4.66-15.78-8.48-3.41-1.72-6.42-3.1-8.82-4.15C912.83,407.73,911.85,405.41,912.22,402.87Z",
    transform: "translate(-86.2 -47.05)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M500.18,635.31c7.5-2.08,14.69,1.74,20.37,4.76,6.2,3.29,19.73,12.14,17.12,18.19s-19.07,5.39-26.92,4.26c-4.85-.69-16.25-2.32-20.17-9.28a10.58,10.58,0,0,1-1.05-7.54C490.56,640.82,494.94,636.76,500.18,635.31Z",
    transform: "translate(-86.2 -47.05)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 471.67,
    cy: 337.69,
    r: 11.63
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 844,
    cy: 98.13,
    r: 27.03
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 255.54,
    cy: 308.39,
    r: 45.13
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404Error.759adf37c58db05d74d68922198671de.svg";
export { ForwardRef as ReactComponent };